import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormattedMessage } from 'react-intl';
import { States } from 'features/PpsiContainer/constants';

export default function DiscardDraftConfirmation({
  data,
  open,
  setOpen,
  handleDiscardDraft,
  typePpsi,
  onPpiDiscardDraft,
  typePpi
}) {
  const handleClose = () => {
    setOpen(false);
  };
  const handleDiscardDraftContinue = () => {
    setOpen(false);
    typePpsi && handleDiscardDraft();
    typePpi && onPpiDiscardDraft();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <FormattedMessage
            id={
              data && data.status === States.SCHEDULED
                ? 'app.discardScheduledMessage'
                : 'app.discardDraftMessage'
            }
          />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <FormattedMessage id="app.confirmPageLeaveMessage" />
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            <FormattedMessage id="app.discardDraftCancel" />
          </Button>
          <Button onClick={handleDiscardDraftContinue} color="primary">
            <FormattedMessage
              id={
                data && data.status === States.SCHEDULED
                  ? 'app.discardScheduledContinue'
                  : 'app.discardDraftContinue'
              }
            />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
